module.exports = __webpack_public_path__ + "img/instituto.0ab41d76.png";